import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentPageRoutes } from './routes/routes.enum';

export const routes: Routes = [
  {
    path: '',
    // component: PaymentPageComponent,
    children: [
      {
        path: PaymentPageRoutes.Order_Summery,
        loadChildren: () => import('./components/order-summery-page/order-summery-page.module').then(m => m.OrderSummeryPageModule),
      },
      {
        path: PaymentPageRoutes.Checkout,
        loadChildren: () => import('./components/checkout-page/checkout-page.module').then(m => m.CheckoutPageModule),
      },
      {
        path: '**',
        redirectTo: PaymentPageRoutes.Order_Summery,
      },
    ] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentPageRoutingModule { }
